/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import type { PretranslatedType } from 'bundles/coursera-plus-landing-page/components/ctaContentful/Pretranslated';
import type { PickedLandingForTool } from 'bundles/coursera-plus-landing-page/contentful/fetchContentful';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import LandingPageEntry from 'bundles/coursera-plus-landing-page/editorTool/LandingPageEntry';

const styles = {
  itemContainer: () => css`
    border-style: solid;
    border-color: #eee;
    border-width: 1px;
    padding: 24px;
    margin: 2px;
  `,
  indented: () => css`
    margin-left: 30px;
  `,
  key: () => css`
    font-weight: bold;
    margin-bottom: 20px;
  `,
};

export const tableStyles = {
  label: () => css`
    text-align: right;
    vertical-align: top;
    opacity: 0.6;
    padding-right: 15px;
  `,
  separator: () => css`
    margin-bottom: 16px;
    margin-top: 8px;
    border-bottom-style: solid;
    border-width: 1px;
    border-color: #ddd;

    :last-child {
      border-color: transparent;
    }
  `,
};

type ListItemProps = {
  pages?: PickedLandingForTool[];
  translation: PretranslatedType;
  translationKey: string;
};

const getReplaceables = (message: string): string[] => {
  const retval: string[] = [];
  const pieces = message.split('{');
  for (const piece of pieces) {
    const closing = piece.indexOf('}');
    if (closing >= 0) {
      retval.push(piece.substring(0, closing));
    }
  }

  return retval;
};

const PretranslatedListItem = (props: ListItemProps) => {
  const { translation, translationKey, pages } = props;

  const message = translation?.message;

  const propsToMessage: Record<string, string> = {};
  if (message) {
    const replaceables: string[] = getReplaceables(message);

    for (const r of replaceables) {
      propsToMessage[r] = '$20';
    }
  }
  return (
    <Typography2 variant="bodyPrimary" component="div" css={styles.itemContainer}>
      <div css={styles.key}>{translationKey}</div>
      <table>
        <tr>
          <td css={tableStyles.label}>Message:</td>
          <td>{message}</td>
        </tr>
        {message && (
          <tr>
            <td css={tableStyles.label}>Example:</td>
            <td>
              <FormattedMessage message={message} {...propsToMessage} />
            </td>
          </tr>
        )}
        <tr>
          <td css={tableStyles.label}>Pages with reference:</td>
          <td>
            {pages &&
              pages.map((page) => {
                return <LandingPageEntry key={page.sys.id} page={page} translationKey={translationKey} />;
              })}

            {!pages && 'none'}
          </td>
        </tr>
      </table>
    </Typography2>
  );
};

export default PretranslatedListItem;
